//TODO: Musi poczekać, bo jest zależne od innych modułów w tej libce

import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
export interface ProductJpkVatGroupItem {
    readonly code: string;
    readonly description: string;
}

export class ProductJpkVatGroupCollectionQuery extends Query<ProductJpkVatGroupItem[]> { }

export class ProductJpkVatGroupCollectionQueryHandlerBase implements QueryHandler<ProductJpkVatGroupCollectionQuery, ProductJpkVatGroupItem[]> {
    private static Url = TaggedUrl.join('products/jpkVatGroups', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: ProductJpkVatGroupCollectionQuery): Promise<ProductJpkVatGroupItem[]> {
        const { data } = await this.http.get<{ items: ProductJpkVatGroupItem[]; }>(ProductJpkVatGroupCollectionQueryHandlerBase.Url);
        return data.items.map(item => ({
            code: item.code,
            description: item.description
        }));
    }
}
